'use strict';

import TS from "@zerolight/zlthunder-time-utils";
import {getFieldName, getFieldTitle, formatMinutes} from '../../shared/utils';
import {getValue, formatValue, safeNumber, formatNumber} from '../../shared/formatters';
import {addSummaries} from "../../shared/summaries";

function safeMinutes(n) {
	n = safeNumber(n);
	return n !== null ? Math.ceil(n / TS.MINUTE) : null;
}

function formatTotalMinutes(n) {
	n = safeMinutes(n);
	return formatNumber(n);
}

function formatSessionLength(n) {
	n = safeNumber(n);
	return n ? formatMinutes(n / 1000) : null;
}

function extendFilter(filter, extension) {
	for (let [key, value] of Object.entries(extension)) {
		let current = new Set(filter[key] || []);
		if (!Array.isArray(value)) {
			value = [value];
		}
		for (let v of value) {
			current.add(v);
		}
		filter[key] = Array.from(current);
	}
	return filter;
}


export {
	getFieldName, getFieldTitle,
	safeNumber, safeMinutes, formatNumber,
	formatTotalMinutes, formatSessionLength,
	getValue, formatValue, extendFilter,
	addSummaries
};